import { render, staticRenderFns } from "./SheetTeacherItemRegister.vue?vue&type=template&id=08a187f5&scoped=true"
import script from "./SheetTeacherItemRegister.vue?vue&type=script&lang=js"
export * from "./SheetTeacherItemRegister.vue?vue&type=script&lang=js"
import style0 from "./SheetTeacherItemRegister.vue?vue&type=style&index=0&id=08a187f5&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "08a187f5",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/runner/work/SysClass-Web-App/SysClass-Web-App/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('08a187f5')) {
      api.createRecord('08a187f5', component.options)
    } else {
      api.reload('08a187f5', component.options)
    }
    module.hot.accept("./SheetTeacherItemRegister.vue?vue&type=template&id=08a187f5&scoped=true", function () {
      api.rerender('08a187f5', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/sys/occurrence/SheetTeacherItemRegister.vue"
export default component.exports